'use client';

import React from 'react';
import Seo from '../../components/Seo';
import HeroSection from './HeroSection';
import WelcomeToXentovra from './WelcomeToXentovra';
import OurCulture from './OurCulture';
import WhyCareerWithUs from './WhyCareerWithUs';
import CareerPath from './CareerPath';
import { careersFaqs } from '@/data/faqs/careersFaqs';
import FAQSection from '@/components/FAQSection';
import CTA from '@/components/CTA';

export default function Careers() {
  const pageUrl = '/careers'

  return (
    <main className="careers-page">
      <Seo
        title="Careers at Xentovra – Join Our Team"
        description="Explore career opportunities at Xentovra Global and join a growing BPO where talent meets opportunity."
        url={pageUrl}
        breadcrumbItems={[
          { name: 'Home', url: 'https://www.xentovra.in/' },
          { name: 'Careers', url: 'https://www.xentovra.in/careers' },
        ]}
      />
      {/* Careers Hero Section */}
      <HeroSection />
      {/* Welcome to Xentovra Section */}
      <WelcomeToXentovra />
      {/* Our Culture Section */}
      <OurCulture />
      {/* Why Career with Us Section */}
      <WhyCareerWithUs />
      {/* Career Path Section */}
      <CareerPath /> 
      {/* FAQ Section */}
      <FAQSection title="Careers FAQs" faqs={careersFaqs} />
      {/* CTA Section */}
      <CTA />
    </main>
  );
}